import { render, staticRenderFns } from "./wxl-btn.vue?vue&type=template&id=de08080c&scoped=true"
import script from "./wxl-btn.vue?vue&type=script&lang=js"
export * from "./wxl-btn.vue?vue&type=script&lang=js"
import style0 from "./wxl-btn.vue?vue&type=style&index=0&id=de08080c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de08080c",
  null
  
)

export default component.exports